import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function CheckmarkIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M20.63 4.223a1 1 0 0 1 .147 1.406l-11.333 14a1 1 0 0 1-1.524.036l-5.667-6.364a1 1 0 1 1 1.494-1.33l4.883 5.485L19.223 4.37a1 1 0 0 1 1.406-.148Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
